export const WPM = 155;

export function estimateSeconds(text) {
  const words = (text || "").trim().split(/\s+/).filter(Boolean).length;
  return Math.round((words / WPM) * 60);
}

export function courseSeconds(sections = []) {
  return (sections || []).reduce((t, s) => t + estimateSeconds(s.narration), 0);
}

export function fmtClock(sec) {
  sec = Math.max(0, Math.round(sec || 0));
  const m = Math.floor(sec / 60);
  const s = sec % 60;
  return `${m}:${String(s).padStart(2, "0")}`;
}

export function fmtDuration(sec) {
  sec = Math.max(0, Math.round(sec || 0));
  if (sec < 60) return `${sec}s`;
  const m = Math.floor(sec / 60);
  const s = sec % 60;
  return s ? `${m}m ${s}s` : `${m}m`;
}

export function fmtMinutes(sec) {
  const m = Math.round((sec || 0) / 60);
  return m < 1 ? "<1 min" : `~${m} min`;
}
